<template>
  <goods-form />
</template>

<script>
import GoodsForm from './components/GoodsForm'

export default {
  name: 'GoodsAdd',
  components: { GoodsForm }
}
</script>
